export default __webpack_public_path__ + "static/media/ms2.1b2116ce.jpg";